import React, { useState } from "react";
import { AdminSidebar } from "./AdminSidebar";
import { ThemeModeSwitch } from "../ThemeModeSwitch";
import { AppUserMenu } from "../AppUserMenu";
import styles from "./AdminLayout.module.css";

interface AdminLayoutProps {
  children: React.ReactNode;
}

export const AdminLayout = ({ children }: AdminLayoutProps) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  return (
    <div className={styles.layout}>
      <AdminSidebar
        collapsed={sidebarCollapsed}
        onToggle={() => setSidebarCollapsed(!sidebarCollapsed)}
      />
      <div
        className={`${styles.content} ${sidebarCollapsed ? styles.sidebarCollapsed : ""}`}
      >
        <header className={styles.header}>
          <div className={styles.headerLeft} />
          <div className={styles.headerRight}>
            <ThemeModeSwitch />
            <AppUserMenu />
          </div>
        </header>
        <main className={styles.main}>{children}</main>
      </div>
    </div>
  );
};
